import React from 'react';
import { Button, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';
import ContestAddNewPopup from './ContestAddNewPopup';

const useStyles = makeStyles(() => ({
  addressHeading: {
    fontFamily: 'Lato',
    textAlign: 'left',
    fontWeight: 500,
    fontSize: '12px',
    lineHeight: '17px',
    color: '#667085',
    marginBottom: 0,
  },
  addressText: {
    fontFamily: 'Lato',
    wordBreak: 'break-all',
    textAlign: 'left',
    fontWeight: 600,
    fontSize: '12px',
    lineHeight: '21px',
    color: '#10182B',
    marginTop: '5px',
  },
  container: {
    overflow: 'auto',
    width: '281px',
    '&::-webkit-scrollbar': { width: '10px' },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 5px grey',
      borderRadius: '20px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'lightGrey',
      borderRadius: '100px',
    },
  },
  editButton: {
    height: '35px',
    marginRight: '10px',
  },
  editDiv: {
    marginTop: '20px',
  },
}));

const LeftSideContest = (props) => {
  const classes = useStyles();
  const contestDetails = useSelector((state) => state.contestData.selectedContestDetails);
  const [isAddnewPopupOpen, setisAddnewPopupOpen] = React.useState(false);

  const closeAddNewContest = () => {
    setisAddnewPopupOpen(false);
  };

  return (
    <>
      <section className={props.customStyles}>
        <Grid
          className={classes.container}
          container
          direction="column"
          justifyContent="flex-start"
          alignItems="flex-start"
        >
          <Grid item>
            <p className={classes.addressHeading}>Categoy</p>
            <p className={classes.addressText}>{contestDetails.category}</p>
          </Grid>
          <Grid item>
            <p className={classes.addressHeading}>Duration Type</p>
            <p className={classes.addressText}>{contestDetails.type}</p>
          </Grid>
          <Grid item>
            <p className={classes.addressHeading}>Timezone</p>
            <p className={classes.addressText}>{contestDetails.timezone}</p>
          </Grid>
          <Grid item>
            <p className={classes.addressHeading}>Dates</p>
            <p className={classes.addressText}>{contestDetails.endDate}</p>
          </Grid>
          <Grid item>
            <p className={classes.addressHeading}>Status</p>
            <p className={classes.addressText}>{contestDetails.enabled ? 'Enabled' : 'Disabled'}</p>
          </Grid>
          <Grid item>
            <p className={classes.addressHeading}>Highlight Top Scores</p>
            <p className={classes.addressText}>{JSON.stringify(contestDetails?.highlightTopScoreLogic)}</p>
          </Grid>
          <Grid item>
            <p className={classes.addressHeading}>Score Parameters</p>
            <p className={classes.addressText}>{JSON.stringify(contestDetails.scoreBreakupParameters, undefined, 2)}</p>
          </Grid>
        </Grid>
      </section>
      <div className={classes.editDiv}>
        <Button
          variant="contained"
          color="primary"
          focusRipple={false}
          onClick={() => {
            setisAddnewPopupOpen((flag) => !flag);
          }}
          className={classes.editButton}
        >
          Edit
        </Button>
      </div>
      {isAddnewPopupOpen && (
        <ContestAddNewPopup
          close={closeAddNewContest}
          add={false}
          selectedData={contestDetails}
          refreshData={props.fetchData}
        />
      )}
    </>
  );
};

export default LeftSideContest;
